import { useI18n } from "@/lib/i18n";
import { getPlanLabel } from "@/lib/plans";

export default function ReferralRewardBalances({ rewards }) {
  const { locale, tx } = useI18n();
  const balances = rewards.byPlan || {
    fun: { activeSeconds: (rewards.activeMonths || 0) * 31 * 86400, bankedSeconds: (rewards.bankedMonths || 0) * 31 * 86400 },
  };
  const duration = (seconds) => tx("{days} days").replaceAll("{days}", new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(Math.max(0, Number(seconds) || 0) / 86400));
  return <div className="mt-4 space-y-4">
    {Object.entries(balances).filter(([plan, balance]) => plan === "fun" || balance.activeSeconds || balance.bankedSeconds).map(([plan, balance]) => (
      <div key={plan} className="rounded-3xl border border-border bg-secondary/30 p-4">
        <h2 className="font-display text-2xl font-bold">{getPlanLabel(plan)}</h2>
        <dl className="mt-3 grid grid-cols-2 gap-3">
          <div><dt className="text-sm text-muted-foreground">{tx("Active")}</dt><dd className="font-bold">{duration(balance.activeSeconds)}</dd></div>
          <div><dt className="text-sm text-muted-foreground">{tx("Banked")}</dt><dd className="font-bold">{duration(balance.bankedSeconds)}</dd></div>
        </dl>
      </div>
    ))}
    <p className="text-sm leading-6 text-muted-foreground">{tx("Banked time starts after paid access ends. It does not reduce automatic payments.")}</p>
  </div>;
}
